<script>
export default {
  name: 'Toggle',

  props: {
    defaultState: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      active: false,
    };
  },

  mounted() {
    this.active = this.defaultState;
  },

  methods: {
    toggle() {
      this.active = !this.active;
    },

    toggleOff() {
      this.active = false;
    },

    toggleOn() {
      this.active = true;
    },
  },

  render() {
    return this.$scopedSlots.default({
      active: this.active,
      toggle: this.toggle,
      toggleOff: this.toggleOff,
      toggleOn: this.toggleOn,
    });
  },
}
</script>